export const onUnloadPage = (showDialog: boolean) => {
  window.onbeforeunload = () => {
    if (showDialog) {
      return true;
    }
    window.onbeforeunload = null;
  };
};

export default onUnloadPage;
